import { triggerToastBar } from "../components/UserInterface/ToastBar";

const copyToClipboard = str => {
  const el = document.createElement("textarea");
  el.value = str;
  document.body.appendChild(el);
  el.select();
  document.execCommand("copy");
  document.body.removeChild(el);

  triggerToastBar();
};

export default copyToClipboard;
